module.exports = __webpack_public_path__ + "static/media/menu-logout-icon.ed0a6797.svg";